import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { deleteCallEvents } from "../../actions/call";
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";

class BusinessOutcomeAlert extends Component {

  constructor(props) {
    super(props);
  }

  close = () => {
      this.props.handleClose(false);
  }

  handleSubmit = () => {
     this.props.deleteCallEvents(this.props.tabsWithoutBusinessOutcome);
     this.props.handleClose(true);
  }

  render(){
    const { translations, selectedLanguage } = this.props;

    return (
      <Modal
        show={this.props.showModal}
        onHide={() => this.close()}
        bsSize="sm"
        backdrop="static"
      >
        <Modal.Header className={`modal-content${this.props.theme} modal-header${this.props.theme}`} closeButton>
          <Modal.Title>{translations.businessOutcome_alert_header[selectedLanguage]}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content${this.props.theme}`}>
          <div className="list-group">
          {translations.businessOutcome_alert_text[selectedLanguage]}
          </div>
        </Modal.Body>
        <Modal.Footer className={`modal-content${this.props.theme}`}>
          <button type="button" onClick={() => this.close()} className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">{translations.cancel[selectedLanguage]}</button>
          <button type="submit" onClick={this.handleSubmit} className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">
            <strong>{translations.close_tab[selectedLanguage]}</strong>
          </button>
        </Modal.Footer>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
    return {
        translations: state.languages.translations,
        selectedLanguage: state.languages.selectedLanguage,
        theme: state.common.theme
    };
}

const mapDispatchToProps = {
	deleteCallEvents,
};

export default connect( mapStateToProps, mapDispatchToProps )(BusinessOutcomeAlert);



// WEBPACK FOOTER //
// ./src/agent/modals/BusinessOutcomeAlert.js